import TransparentLogoAsset from "../../node_modules/@weretradeit/assets/media/Transparent Logo Asset.png";

export const Transparent_Logo_Asset = TransparentLogoAsset;
